import { mapFillColorStrategy } from "./MapConstants";

const yellowScaleColors = ["#ffffdd", "#ffff84", "#fff900", "#ffb600", "#ff7800"];

export const defaultConfiguration = (
  props,
  minZoomValue,
  maxZoomValue,
  areaname,
  claimFlag,
  isRiskYearsFlagToShow,
) => {
  const doc = isRiskYearsFlagToShow
    ? {
        it: "rischi anno alla qualsiasi pericolo legato al meteo",
        en: "risk-years for any weather-related hazard",
      }
    : claimFlag
      ? { it: "denunce", en: "claims" }
      : props.page === "agriculture-policies"
        ? { it: "contratti", en: "policies" }
        : { it: "ubicazioni", en: "locations" };
  const propertyName =
    props.page === "agriculture-claims"
      ? "no_denunce"
      : props.page === "buildings-claims"
        ? "no_denunce"
        : props.page === "agriculture-policies"
          ? "no_contratti"
          : props.page === "buildings-policies"
            ? "dbb_no_policies"
            : "WRONG_PROPERTY_NAME";

  return {
    colorList: yellowScaleColors,
    strategy: mapFillColorStrategy.interpolate,
    colorText: {
      en: [
        "Very low number of " + doc.en,
        "Low number of " + doc.en,
        "Medium number of " + doc.en,
        "High high number of " + doc.en,
        "Very high number of " + doc.en,
      ],
      it: [
        "Molto basso numero di " + doc.it,
        "Basso numero di " + doc.it,
        "Medio numero di " + doc.it,
        "Alto numero di " + doc.it,
        "Molto alto numero di " + doc.it,
      ],
    },
    colorForZero: "white",
    comment: "hue scale based:     violet=less than 10%     green=50%     red=more than 80%",
    opacities: {
      zero: 0.2,
      nonZero: 0.4,
    },
    propertyName: propertyName,
    textColor: "black",
    maxzoom: maxZoomValue,
    minzoom: minZoomValue,
    legendTitle: {
      en: "Number of " + doc.en + " for every " + areaname,
      it: "Numero di " + doc.it + " per " + areaname,
    },
    legendFootnote: {
      en:
        "Number is computed as the sum of the number of  " +
        doc.en +
        " for every " +
        areaname +
        " according to current Reale data",
      it:
        "Numero calcolato come somma del numero di  " +
        doc.it +
        " per ogni " +
        areaname +
        " secondo i dati attuali di Reale",
    },
    legendLicense: {
      en: "© Cystellar 2023, (c) Reale Mutua 2023, all rights reserved",
      it: "© Cystellar 2023, (c) Reale Mutua 2023, tutti i diritti riservati",
    },
    legendWithoutAddresses: {
      en: "locations without addresses",
      it: "ubicazioni senza indirizzo",
    },
  };
};

export const defaultBivariateConfiguration = () => {
  return {
    colorList: [
      "#00af00",
      "#e8e8e8",
      "#e4acac",
      "#c85a5a",
      "#b0d5df",
      "#ad9ea5",
      "#985356",
      "#64acbe",
      "#62718c",
      "#574249",
    ],
    strategy: mapFillColorStrategy.step,
    colorText: {
      en: [
        "Zone 0: No hazard data",
        "Zone 1: Low KPI    Low hazard level",
        "Zone 2: Low KPI    Medium hazard level",
        "Zone 3: Low KPI    High hazard level",
        "Zone 4: Medium KPI Low hazard level",
        "Zone 5: Medium KPI Medium hazard level",
        "Zone 6: Medium KPI High hazard level",
        "Zone 7: High KPI   Low hazard level",
        "Zone 8: High KPI   Medium hazard level",
        "Zone 9: High KPI   High hazard level",
      ],
      it: [
        "Zona 0: Nessun dato di pericolo",
        "Zona 1: Basso KPI Basso livello di pericolo",
        "Zona 2: Basso KPI Media livello di pericolo",
        "Zona 3: Basso KPI Alto  livello di pericolo",
        "Zona 4: Media KPI Basso livello di pericolo",
        "Zona 5: Media KPI Media livello di pericolo",
        "Zona 6: Media KPI Alto  livello di pericolo",
        "Zona 7: Alto  KPI Basso livello di pericolo",
        "Zona 8: Alto  KPI Media livello di pericolo",
        "Zona 9: Alto  KPI Alto  livello di pericolo",
      ],
    },
    keyValues: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    colorForZero: "white",
    comment: "Class based",
    opacities: {
      zero: 0.2,
      nonZero: 0.85,
    },
    propertyName: "bivariateProperty",
    textColor: "black",
    maxzoom: 12,
    minzoom: 2,
    legendTitle: {
      en: "KPI and hazard level Classification",
      it: "Classificazione per KPI e livello di pericolo",
    },
    legendFootnote: {
      en: "\n \n Red means high hazard level;\n blue means high KPI;\n cherry means that both are high",
      it: "\n \n Il rosso significa alto livello di pericolo;\n il blu indica un KPI elevato;\n cherry significa che entrambi sono alti",
    },
    legendLicense: {
      en: "© CyStellar, Data from Dipartimento della Protezione Civile processed by CyStellar",
      it: "© CyStellar, Dati Dipartimento della Protezione Civile elaborato da CyStellar",
    },
  };
};
